import { Dispatch, SetStateAction, createContext } from 'react';
import { DataRoomDashboardStats, DealRoom } from 'models/DealRoom';
import { Listing, ListingEnquiry } from 'models/Listing';
import { DropzoneDelete, DropzoneUpload } from 'models/Dropzone';
import { Lead } from 'models/Lead';
import { DropzoneFile } from 'components/Dropzone/utils';
import utils from 'utils';
import {
  WorkflowConfiguration,
  WorkflowConfigurationSteps,
  WorkflowConfigurationStepsCapacity,
} from 'models/WorkflowConfiguration';

type ListingContextProps = {
  listing: Partial<Listing>;
  dealRoom: DealRoom;
  gallery: DropzoneFile[];
  enquiry: Partial<ListingEnquiry>;
  workflowConfigurationStepsCapacity: WorkflowConfigurationStepsCapacity;
  dashboardStats: DataRoomDashboardStats;
  isTableView: boolean;
  isUploading: boolean;
  workflowConfiguration: WorkflowConfigurationSteps;
  areActionsDisabled: boolean;
  canManageDeal: boolean;
  hasUnlockPremiumFeatures: boolean;
  statsIsFetching: boolean;
  canAccessDataRoom: boolean;
  isListingOwner: boolean;
  isTransferringDeal: boolean;
  leads: Partial<Lead>[];
  updateWorkflow: (
    workflowConfiguration: Partial<WorkflowConfiguration>,
  ) => void;
  refetchLeads: () => void;
  onTransferToEnterpriseColleague: (
    userId: string,
    userFullName: string,
  ) => Promise<{
    isSuccessfully: boolean;
  }>;
  setIsUploading: Dispatch<SetStateAction<boolean>>;
  setListing: Dispatch<SetStateAction<Partial<Listing>>>;
  setEnquiry: Dispatch<SetStateAction<Partial<ListingEnquiry>>>;
  setDealRoom: Dispatch<SetStateAction<DealRoom>>;
  setWorkflowConfiguration: Dispatch<
    SetStateAction<WorkflowConfigurationSteps>
  >;
  updateGallery: (images: DropzoneFile[]) => void;
  deleteListingFile: DropzoneDelete;
  uploadListingFile: DropzoneUpload;
};

export default createContext<Partial<ListingContextProps>>({
  listing: null,
  gallery: [],
  enquiry: null,
  workflowConfiguration: null,
  workflowConfigurationStepsCapacity: null,
  dashboardStats: null,
  isTableView: false,
  isUploading: false,
  areActionsDisabled: false,
  canManageDeal: true,
  hasUnlockPremiumFeatures: false,
  statsIsFetching: false,
  canAccessDataRoom: false,
  isListingOwner: false,
  isTransferringDeal: false,
  leads: [],
  updateWorkflow: utils.noop,
  refetchLeads: utils.noop,
  onTransferToEnterpriseColleague: utils.noop,
  setListing: utils.noop,
  setEnquiry: utils.noop,
  setDealRoom: utils.noop,
  updateGallery: utils.noop,
  setIsUploading: utils.noop,
});
